export const MAX_SIZE_COLUMN = 6

export const DEFAULT_STYLE = 'style2'
